/** @module csi/widget/CustomIconWithLabel */
define([
	"dojo/_base/declare",
	"dojo/text!./CustomIconWithLabel.html",
	"./MaterialIconWithLabel"
], function(declare,template,MaterialIconWithLabel) {

	const _CustomIconWithLabel = declare(MaterialIconWithLabel, {
		templateString: template
	});

	/**
	 * Return HTML for widget rather than widget itself
	 * @param {Object} params
	 * @return {string}
	 */
	_CustomIconWithLabel.getIconHtml = function(params) {
		const w = new _CustomIconWithLabel(params);
		const value = w.domNode.outerHTML;

		// needed to remove widget from registry
		w.destroy();

		return value;
	};

	return _CustomIconWithLabel;
});